/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocArrowOutIcon20Solid = forwardRef('DocArrowOutIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7 2h3.004v3.748a2.25 2.25 0 0 0 2.25 2.25H16v1.627a2.372 2.372 0 0 0-2.291 3H13.5A5.875 5.875 0 0 0 7.646 18H7a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3Z" }),
        React.createElement("path", { d: "m11.504 2.139 4.36 4.359h-3.61a.75.75 0 0 1-.75-.75V2.139Z" }),
        React.createElement("path", { d: "M13.5 16a2.5 2.5 0 0 0-2.5 2.5v.5a1 1 0 1 1-2 0v-.5a4.5 4.5 0 0 1 4.5-4.5h3.297l-1.448-1.24a1 1 0 0 1 1.302-1.52l2.614 2.242a2 2 0 0 1 0 3.037l-2.614 2.24a1 1 0 0 1-1.302-1.518L16.797 16H13.5Z" })));
});
